<template>
    <div class="relative">
        <div
            v-if="! selectedProject"
            class="text-white px-lg pt-lg pb-0 w-full bg-white flex justify-between items-center fixed z-10"
        >
            <div class="m-0 flex-1 w-full md:w-auto">
                <select-input
                    v-model="selectedProjectId"
                    placeholder="Välj"
                    :options="projects"
                >
                    Välj projekt
                </select-input>
            </div>

            <div class="flex-1 mb-lg">
                <div v-if="selectedProject" class="flex ml-xl">
                    <font-awesome-icon icon="map-marker-alt" class="mr-sm" />
                    {{ addressesCount }} adresser
                </div>
            </div>
        </div>
        <sales-period-assign
            v-if="selectedProject && salesPeriod"
            :project="selectedProject"
            :sales-period="salesPeriod"
            :is-field-view="true"
            :can-draw="true"
        />
        <base-map
            v-else
            ref="baseMap"
            :zoom="5"
            map-height="90vh"
        />
    </div>
</template>

<script>
    export default {
        props: {
            projects: {
                type: Object,
                required: true,
            },
            initialProject: {
                type: Object,
                default: null,
            },
        },

        data() {
            return {
                selectedProjectId: null,
                selectedProject: null,
                salesPeriod: null,
                addressesCount: null,
            };
        },

        watch: {
            selectedProjectId() {
                if (! this.selectedProjectId) {
                    return;
                }

                axios.get(route('api.sales-projects.sales-periods.index', this.selectedProjectId))
                    .then(({ data }) => {
                        this.selectedProject = data.salesProject;
                        this.addressesCount = data.addresses_count;
                        this.salesPeriod = data.salesPeriod;
                    });
            },
        },

        created() {
            if (this.initialProject) {
                this.selectedProjectId = this.initialProject.id;
            } else {
                this.selectedProjectId = '';
            }
        },
    };
</script>
